// This file contains the logic for personalizing the Uncover page content
export interface UserPreference {
  bodyTypes: string[]
  moods: string[]
  fetishes: string[]
  relationshipStatus: string
  insecurityFlags: string[]
  recentInterests: string[]
  recentPurchases: string[]
}
export interface BannerAd {
  id: string
  title: string
  description: string
  image: string
  ctaText: string
  ctaLink: string
  type: 'enlargement' | 'privacy' | 'toy' | 'hair' | 'general'
}
// Sample banner ads
const bannerAds: BannerAd[] = [
  {
    id: 'enlargement',
    title: 'Feeling small? Make her feel more 💦',
    description:
      'Our premium enlargement formula is trusted by thousands of men worldwide',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/fCPSY7KsXRCCXMoMKQQvkn/enlargement-ad.jpg',
    ctaText: 'Get Bigger Now',
    ctaLink: '/marketplace/enlargement',
    type: 'enlargement',
  },
  {
    id: 'privacy',
    title: 'In a relationship? Use SinShift VPN 🔒',
    description: 'Browse in complete privacy. No one will ever know.',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/fCPSY7KsXRCCXMoMKQQvkn/privacy-ad.jpg',
    ctaText: 'Get Protected',
    ctaLink: '/marketplace/vpn',
    type: 'privacy',
  },
  {
    id: 'toy',
    title: 'Turn up the vibe – her favorite toy is waiting 🎮',
    description: "Sync with your angel's toy for a real-time experience",
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/fCPSY7KsXRCCXMoMKQQvkn/toy-ad.jpg',
    ctaText: 'Sync Now',
    ctaLink: '/marketplace/toys',
    type: 'toy',
  },
  {
    id: 'hair',
    title: 'Hair today, more tomorrow 🌿',
    description: 'Our clinically proven formula stops hair loss in 97% of men',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/fCPSY7KsXRCCXMoMKQQvkn/hair-ad.jpg',
    ctaText: 'Regrow Now',
    ctaLink: '/marketplace/hair',
    type: 'hair',
  },
]
// Mock user preferences for demo purposes
// In a real app, this would come from user data
const mockUserPreference: UserPreference = {
  bodyTypes: ['curvy', 'fit'],
  moods: ['playful', 'dominant'],
  fetishes: ['lingerie', 'role-play'],
  relationshipStatus: 'single',
  insecurityFlags: ['small_dick', 'hair_loss'],
  recentInterests: ['toys', 'lingerie'],
  recentPurchases: ['premium_subscription'],
}
export const getUserPreferences = (): UserPreference => {
  // In a real app, this would fetch from an API or local storage
  return mockUserPreference
}
export const getPersonalizedBanners = (
  preferences: UserPreference,
): BannerAd[] => {
  const personalizedBanners: BannerAd[] = []
  // Prioritize based on insecurity flags
  if (preferences.insecurityFlags.includes('small_dick')) {
    personalizedBanners.push(bannerAds.find((ad) => ad.type === 'enlargement')!)
  }
  if (preferences.insecurityFlags.includes('hair_loss')) {
    personalizedBanners.push(bannerAds.find((ad) => ad.type === 'hair')!)
  }
  // Add privacy VPN if in relationship
  if (
    preferences.relationshipStatus === 'in_relationship' ||
    preferences.relationshipStatus === 'married'
  ) {
    personalizedBanners.push(bannerAds.find((ad) => ad.type === 'privacy')!)
  }
  // Add toy sync if interested in toys
  if (preferences.recentInterests.includes('toys')) {
    personalizedBanners.push(bannerAds.find((ad) => ad.type === 'toy')!)
  }
  // Fill remaining with random ads if needed
  const remainingAds = bannerAds.filter(
    (ad) => !personalizedBanners.includes(ad),
  )
  while (personalizedBanners.length < 4 && remainingAds.length > 0) {
    const randomIndex = Math.floor(Math.random() * remainingAds.length)
    personalizedBanners.push(remainingAds[randomIndex])
    remainingAds.splice(randomIndex, 1)
  }
  return personalizedBanners
}
// Mock function to get personalized angel content
// In a real app, this would use actual user data and angel content
export const getPersonalizedContent = () => {
  const preferences = getUserPreferences()
  // This is where you'd implement the actual personalization logic
  return {
    preferences,
    banners: getPersonalizedBanners(preferences),
  }
}
